


































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { PrivateWorker } from '@/types/user'
import { TeamMember } from '@/types/team'
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import { PatientListItem } from './PatientSearchField.vue'
import { Worker } from '@/types/user.ts'
import ky from 'ky'

@Component({
  components: {
    InfiniteLoading,
    Loading: () => import('@/components/common/loadings/Index.vue'),
    Modal: () => import('@/components/common/modals/Modal.vue')
  }
})
export default class WorkerSearch extends Vue {
  @Prop({ type: Object, default: null }) currentPatient!: PatientListItem | null

  $store!: ExStore
  workerPageNumber = 1
  selectOccupationCode: string | null = null
  searchWorker = ''

  requestPending = true
  loadingFirst = true
  infinitateLoadingIdentifier = 0
  selectWorkers: { [id: number]: boolean } = {}

  editingWorker: Worker | null = null

  get myWorkerInfo() {
    return this.$store.getters['user/workerInfo'] as PrivateWorker
  }

  get workerIds() {
    return this.$store.getters['worker/sort'].filter(
      id => !this.teamMemberDict[id]
    )
  }

  get workers() {
    return this.$store.getters['worker/workers']
  }

  get workerTotalCount() {
    return this.$store.getters['worker/totalCount'] || 0
  }

  get hasWorkerNextPage() {
    return this.workerTotalCount > this.workerIds.length
  }

  get occupations() {
    return this.$store.getters['occupation/occupation']
  }

  get teamMembers() {
    return this.$store.getters['team/teamMembers']
  }

  get teamMemberDict() {
    return this.teamMembers.reduce((dict, member) => {
      return Object.assign(dict, {
        [member.worker.id]: member
      })
    }, {} as { [id: number]: TeamMember })
  }

  @Watch('selectOccupationCode')
  async handleSelectOccupationCode() {
    await this.searchWorkers()
  }

  @Watch('searchWorker')
  async handleInputSearchWorker() {
    await this.searchWorkers()
  }

  @Watch('currentPatient')
  async handleChangeCurrentPatient() {
    await this.searchWorkers()
  }

  async searchWorkers() {
    const query = this.searchWorker || ''
    const occupation = this.selectOccupationCode || ''

    await this.$store.dispatch('worker/updateList', {
      scope: 'group',
      occupation,
      query
    })
    this.workerPageNumber = 1
    this.infinitateLoadingIdentifier++
  }

  async handleReachEnd($state: StateChanger) {
    if (this.requestPending) {
      $state.loaded()
      return
    }

    try {
      this.requestPending = true

      if (!this.hasWorkerNextPage) {
        $state.complete()
        return
      }

      await this.loadPage(this.workerPageNumber + 1)

      this.workerPageNumber++
      $state.loaded()
    } catch (err) {
      $state.complete()
    } finally {
      this.requestPending = false
    }
  }

  async loadPage(page: number) {
    const query = this.searchWorker || ''
    const occupation = this.selectOccupationCode || ''

    return await this.$store.dispatch('worker/add', {
      scope: 'group',
      occupation,
      query,
      page
    })
  }

  async handleAddMembers() {
    if (!this.currentPatient) {
      return
    }

    const members = this.workerIds
      .filter(id => this.selectWorkers[id] && !this.teamMemberDict[id])
      .map(id => ({
        isAdmin: false,
        isEnabled: true,
        worker: id,
        patient: (this.currentPatient as PatientListItem).id
      }))
      .concat(
        this.teamMembers.map(params => ({
          ...params,
          worker: params.worker.id
        }))
      )

    await this.$store.dispatch('team/putTeamMembers', {
      patientId: this.currentPatient.id,
      params: { members }
    })

    this.selectWorkers = {}
  }

  handleEditStaffnumber(worker: Worker) {
    this.editingWorker = Object.assign({}, worker)
  }

  async handleEditSubmit() {
    if (!this.editingWorker) return
    try {
      this.$api.user.patchWorker({
        workerId: this.editingWorker?.id,
        params: { staffNumber: this.editingWorker.staffNumber }
      })
      this.$store.dispatch('worker/updateWorker', this.editingWorker)
      this.editingWorker = null
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
      console.error(e)
    }
  }

  handleEditClose() {
    this.editingWorker = null
  }

  async created() {
    try {
      this.requestPending = true
      this.loadingFirst = true
      await this.$store.dispatch('worker/updateList', { scope: 'group' })
    } catch (error) {
      //
    } finally {
      this.requestPending = false
      this.loadingFirst = false
    }
  }
}
